export const updateEntityMutation = () => {
    return `
    mutation UpdateEntity(
        $entityId: Int!,
        $location: String
    ) {
        updateEntity(
            entityId: $entityId,
            location: $location
        ) {
            entity {
                id
                name
                abbreviation
                location
            }
        }
    }
    `
}
